import React from 'react';
import './Input.css';

const Input = ({type, disabled, placeholder, value, className, onChange, onBlur, maxLength}) => (
	<input
		type={type}
		disabled={disabled}
		placeholder={placeholder}
		value={value}
		className={`Input ${className || ''} ${disabled ? 'disabled' : ''}`}
		onChange={onChange}
		onBlur={onBlur}
		maxLength={maxLength}
	/>
);

export default Input;


// WEBPACK FOOTER //
// ./src/widgets/Input.js